import React from 'react'

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))
const Usuarios = React.lazy(() => import('./views/pages/users/Users'))
const CadastroUsuarios = React.lazy(() =>
  import('./views/pages/users/register_users/RegisterUsers'),
)
const ClientsExport = React.lazy(() => import('./views/pages/clients/exportacao/ClientsExport'))
const ClientsRegister = React.lazy(() => import('./views/pages/clients/register/ClientsRegister'))
const ClientsApprobation = React.lazy(() =>
  import('./views/pages/clients/approbation/ClientsApprobation'),
)
const ReportsApprobation = React.lazy(() =>
  import('./views/pages/reports/approbation-reports/ReportsApprobation'),
)
const ReportsUsers = React.lazy(() => import('./views/pages/reports/user-reports/ReportsUsers'))
const RegistrationAnalysis = React.lazy(() =>
  import('./views/pages/reports/registrationAnalysis/RegistrationAnalysis'),
)

const routes = [
  { path: '/', name: '', element: Dashboard },
  { path: '/dashboard', name: 'Dashboard', element: Dashboard },
  { path: '/usuarios', name: 'Usuários', element: Usuarios },
  { path: '/usuarios/cadastros', name: 'Cadastro', element: CadastroUsuarios },
  { path: '/clientes/exportacao', name: 'Clientes Exportação JDE', element: ClientsExport },
  { path: '/clientes/cadastro', name: 'Clientes Cadastro', element: ClientsRegister },
  { path: '/clientes/aprovacao', name: 'Aprovação Clientes', element: ClientsApprobation },
  {
    path: '/auditoria/controle-aprovacao',
    name: 'Auditoria Controle Aprovação',
    element: ReportsApprobation,
  },
  {
    path: '/auditoria/controle-usuarios',
    name: 'Auditoria Controle usuário',
    element: ReportsUsers,
  },
  {
    path: '/relatorios/analise-cadastro',
    name: 'Análise de cadastro',
    element: RegistrationAnalysis,
  },
]

export default routes
